import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Popover } from 'antd';
import { Icon } from '@fuxi/eevee-icon';
import checkImg from '@/assets/image/check-img.png';
import halfCheckImg from '@/assets/image/half-check.png';
import notCheckImg from '@/assets/image/not-check-img.png';
import { ScrollViewRefAttrs } from '@/components/scroll-view';
import { ScrollView } from '@/components';

import cx from './index.module.scss';

interface Props {
  list: Array<{
    value: string;
    text: string;
    subText?: string;
  }>;
  value: string[];
  onChange: (value: Props['value']) => void;
  filterName: string;
  allSelectText?: string;
  className?: string;
  multiple?: boolean;
}

const SlideFilter: React.FC<Props> = ({
  value,
  onChange,
  className,
  filterName,
  list,
  allSelectText,
  multiple = true,
}) => {
  const scrollViewRef = useRef<ScrollViewRefAttrs>(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const currentIsAllSelect = useMemo(() => value?.length === list?.length, [list, value]);

  const PopoverContent = useMemo(
    () => (
      <ScrollView ref={scrollViewRef} className={cx('select-list')}>
        <div>
          {allSelectText && (
            <div
              className={cx('select-item')}
              onClick={() => onChange(currentIsAllSelect ? [] : list.map(item => item.value))}
            >
              {currentIsAllSelect ? (
                <img className={cx('check-state-img')} src={checkImg} alt="" />
              ) : value?.length ? (
                <img className={cx('check-state-img')} src={halfCheckImg} alt="" />
              ) : (
                <img className={cx('check-state-img')} src={notCheckImg} alt="" />
              )}

              <div className={cx('select-item-name')}>
                <div className={cx('main-text')}>{allSelectText}</div>
              </div>
            </div>
          )}
          {list?.map(item => (
            <div
              key={item.value}
              className={cx('select-item')}
              onClick={() => {
                const currenIsChecked = value?.some(item2 => item.value === item2);

                if (multiple) {
                  onChange(currenIsChecked ? value?.filter(item2 => item2 !== item.value) : [...value, item.value]);
                } else {
                  // 单选时，值不同才触发onChange
                  value?.[0] !== item.value && onChange([item.value]);
                }
              }}
            >
              <img
                className={cx('check-state-img')}
                src={value?.some(item2 => item.value === item2) ? checkImg : notCheckImg}
                alt=""
              />
              <div className={cx('select-item-name')}>
                <div className={cx('main-text')}>{item.text}</div>
                {!!item.subText && <div className={cx('sub-text')}>{item.subText}</div>}
              </div>
            </div>
          ))}
        </div>
      </ScrollView>
    ),
    [allSelectText, currentIsAllSelect, list, multiple, onChange, value]
  );

  useEffect(() => {
    if (list?.length) {
      scrollViewRef.current?.handleRefresh();
    }
  }, [list?.length, allSelectText]);

  return (
    <div className={cx('SlideFilter', className)}>
      {isPopoverOpen && <div className={cx('popover-mask')} onClick={() => setIsPopoverOpen(false)} />}
      <Popover
        getPopupContainer={container => container}
        content={PopoverContent}
        title={null}
        arrow={false}
        placement="bottomLeft"
        open={isPopoverOpen}
        destroyOnHidden={true}
        trigger="click"
      >
        <div className={cx('wrapper')} onClick={() => setIsPopoverOpen(true)}>
          <div className={cx('wrapper-text')}>
            {value?.length
              ? list
                  ?.filter(item => value?.includes(item.value))
                  .map(item => item.text)
                  ?.join('、')
              : filterName}
          </div>
          <Icon name="select" size={18} />
        </div>
      </Popover>
    </div>
  );
};

export default SlideFilter;
